import React from 'react'
import { useState } from 'react';
import './Chatbot.css';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Index } from "./Index";
import { Asset } from "./Asset";
import { Client } from "./Client"
import { TopHoldingsTabs } from "./TopHoldingTabs";
export const AiDashboard = () => {

    const [activeTab, setActiveTab] = useState("IndexPerformance");

    const handleTabChange = (eventKey) => {
        setActiveTab(eventKey);
    };

   
   
    return (
        <>    
            <div className="bg-white border h-400 rounded">
                <div className ="white-container">                   
                    <Tabs
                        activeKey={activeTab}
                        id="uncontrolled-tab-example"
                        className="ms-3 AITabs"
                        onSelect={handleTabChange}
                    >
                        <Tab eventKey="IndexPerformance" title="Index Performance" >
                            {activeTab === "IndexPerformance" && <Index></Index>}
                        </Tab>
                        <Tab eventKey="AssetPerformance" title="Asset Performance" >
                            {activeTab === "AssetPerformance" && <Asset></Asset>}
                        </Tab>
                        <Tab eventKey="ClientPerformance" title="Client Performance" >
                            {activeTab === "ClientPerformance" && <Client></Client>}
                        </Tab>
                      
                     
                       
                    </Tabs>
                    <TopHoldingsTabs />
                </div> 
                   
            </div>

















          
                            
                        
        </>
    )
}

